import { Fragment, useEffect, useState } from "react";
import { Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { formatCurrency0Digit } from "../../../../utility/Utils";
import Avatar from "@components/avatar";
import "@styles/base/pages/app-ecommerce.scss";
import {
  FileText,
  User,
  MapPin,
  ArrowLeft,
  CheckCircle,
  Delete,
  Info,
  PieChart,
  Edit,
  Trash2,
  CreditCard,
  Calendar,
} from "react-feather";
import {
  Row,
  Col,
  CardText,
  UncontrolledTooltip,
  FormGroup,
  CustomInput,
  Label,
} from "reactstrap";
import UILoader from "@components/ui-loader";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getCourseDetail, saveCourseRegistration } from "../action";

const MySwal = withReactContent(Swal);

const confirmRegistrationSuccess = ({ title }) => {
  return MySwal.fire({
    title: title,
    text: "",
    icon: "success",
    confirmButtonText: "ตกลง",
    cancelButtonText: "ปิด",
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: true,
  });
};

const confirmRegistrationError = ({ statusCode, statusDesc }) => {
  return MySwal.fire({
    title: "ลงทะเบียนไม่สำเร็จ",
    text: statusDesc,
    icon: "error",
    confirmButtonText: "ตกลง",
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: true,
  });
};

const handleConfirmText = ({ callbackFunction, title, text }) => {
  return MySwal.fire({
    title: title,
    text: text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "ตกลง",
    cancelButtonText: "ปิด",
    customClass: {
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then(function (result) {
    if (result.value) {
      callbackFunction();
    }
  });
};

const PaymentDetailsV2 = (props) => {
  const {
    payment,
    data,
    transactionCourseUser,
    transactionPaymentProofs,
    getCourseDetail,
    deleteWishlistItem,
    dispatch,
    addToWishlist,
    getProduct,
    productId,
    addToCart,
  } = props;

  const [selectedColor, setSelectedColor] = useState("primary");
  const [userData, setUserData] = useState(null);

  const handleWishlist = (val) => {
    if (val) {
      dispatch(deleteWishlistItem(productId));
    } else {
      dispatch(addToWishlist(productId));
    }
    dispatch(getProduct(productId));
  };

  const handleCartBtn = (id, val) => {
    if (val === false) {
      dispatch(addToCart(id));
    }
    dispatch(getProduct(productId));
  };

  const CartBtnTagCancel = "button-cancel";

  function callBackFunctionRegistration({ type, data }) {
    if (data.statusCode === "0" || data.statusCode === 0) {
      confirmRegistrationSuccess({ title: "ลงทะเบียนเรียบร้อย" });
      dispatch({ type: type, data: data });
    } else {
      confirmRegistrationError({
        statusCode: data.statusCode,
        statusDesc: data.statusDesc,
      });
    }
  }

  function callBackFunctionCancel({ type, data }) {
    if (data.statusCode === "0" || data.statusCode === 0) {
      confirmRegistrationSuccess({ title: "ยกเลิกการลงทะเบียนเรียบร้อย" });
      dispatch({ type: type, data: data });
    } else {
      confirmRegistrationError({
        statusCode: data.statusCode,
        statusDesc: data.statusDesc,
      });
    }
  }

  function cancelCourseRegistrationActionConfirm() {
    saveCourseRegistration({
      courseId: data.id,
      dispatch: dispatch,
      transactionCourseUserStatus: "CANCEL",
      callBackFunction: callBackFunctionCancel,
    });
  }

  function saveCourseRegistrationActionConfirm() {
    saveCourseRegistration({
      courseId: data.id,
      dispatch: dispatch,
      transactionCourseUserStatus: "WAIT_PAYMENT",
      callBackFunction: callBackFunctionRegistration,
    });
  }

  function saveCourseRegistrationAction() {
    handleConfirmText({
      callbackFunction: saveCourseRegistrationActionConfirm,
      title: "ต้องการลงทะเบียน ใช่หรือไม่",
      text: "",
    });
  }

  function cancelCourseRegistrationAction() {
    handleConfirmText({
      callbackFunction: cancelCourseRegistrationActionConfirm,
      title: "ต้องการยกเลิกการลงทะเบียน ใช่หรือไม่",
      text: "",
    });
  }

  useEffect(() => {
    setUserData(JSON.parse(localStorage.getItem("userData")));
  }, []);

  const invoiceStatusObj = {
    PAYMENT_SUCCESS: {
      color: "light-success",
      icon: CheckCircle,
      text: "อนุมัติการลงทะเบียน",
    },
    APPROVE_SUCCESS: {
      color: "light-success",
      icon: CheckCircle,
      text: "อนุมัติการลงทะเบียน",
    },
    CANCEL: { color: "light-danger", icon: Delete, text: "ยกเลิก" },
    WAIT_PAYMENT: {
      color: "light-warning",
      icon: PieChart,
      text: "รอยืนยันการชำระเงิน",
    },
    WAIT_ADMIN_APPROVE: {
      color: "light-warning",
      icon: PieChart,
      text: "รอตรวจสอบการชำระเงิน",
    },
  };
  const generateCourses = () => {
    const color =
        transactionCourseUser && transactionCourseUser.status
          ? invoiceStatusObj[transactionCourseUser.status].color
          : "primary",
      Icon =
        transactionCourseUser && transactionCourseUser.status
          ? invoiceStatusObj[transactionCourseUser.status].icon
          : Edit;
    const textTooltip =
      transactionCourseUser && transactionCourseUser.status
        ? invoiceStatusObj[transactionCourseUser.status].text
        : "";

    return (
      <Row className="my-2">
        <Col md="9" xs="12">
          <h4>{data.courseName}</h4>

          {userData &&
          data.courseIsMember === true &&
          userData.role === "user" ? (
            <div className="ecommerce-details-price d-flex flex-wrap mt-1">
              <h4 className="item-price mr-1">
                {data.price1 && data.price1 > 0
                  ? "ค่าลงทะเบียน (สมาชิก " +
                    data.memberName +
                    ") " +
                    formatCurrency0Digit(data.price1) +
                    " บาท"
                  : "ฟรี"}
              </h4>
            </div>
          ) : null}

          {userData &&
          data.courseIsMember !== true &&
          userData.role === "user" ? (
            <div className="ecommerce-details-price d-flex flex-wrap mt-1">
              <h4 className="item-price mr-1">
                {data.price2 && data.price2 > 0
                  ? "ค่าลงทะเบียน (สมาชิกนอกเครือข่าย " +
                    data.memberName +
                    ") " +
                    formatCurrency0Digit(data.price2) +
                    " บาท"
                  : "ฟรี"}
              </h4>
            </div>
          ) : null}
          <CardText className="item-description">
            <Avatar
              color={color}
              icon={<Icon size={16} />}
              id={`av-tooltip-${data.id}`}
            />
            <UncontrolledTooltip
              placement="top"
              target={`av-tooltip-${data.id}`}
            >
              <span className="font-weight-bold">{textTooltip}</span>
            </UncontrolledTooltip>
            สถานะการลงทะเบียน : {textTooltip}
          </CardText>
          <CardText className="item-description">
            <Avatar
              color={color}
              icon={<Calendar size={16} />}
              id={`av-tooltip-${data.id}`}
            />
            <UncontrolledTooltip
              placement="top"
              target={`av-tooltip-${data.id}`}
            >
              <span className="font-weight-bold">{textTooltip}</span>
            </UncontrolledTooltip>
            ชำระเงินภายในวันที่ {data.dueDateStr ? data.dueDateStr : "-"}
          </CardText>
        </Col>
      </Row>
    );
  };

  return <div>{generateCourses()}</div>;
};

export default PaymentDetailsV2;
